<template>
  <div
    class="tiss-field mx-1"
    :style="{ width: largura, height: altura }"
    style="
    border-style: solid;
    border-width: 1px;
    -webkit-print-color-adjust: exact;"
  >
    <div class="ml-1 font-weight-bold" style="font-size: 6pt;">
      <span class="d-flex flex-row" v-html="titleHTML"></span>
    </div>
    <div class="ml-1 font-weight-bold" style="font-size: 7pt;">
      <span v-html="assinaturas"></span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    quantidade: {
      type: Number,
      default: 1
    },
    colunas: {
      type: Number,
      default: 1
    },
    title: {
      type: Array
    },
    largura: {
      type: String,
      default: "7cm"
    },
    altura: {
      type: String,
      default: "1.2cm"
    },
    datas: { 
      type: Array, 
      default: null, 
    }
  },
  computed: {
    titleHTML: function() {
      let titleHTML = "";
      this.title.forEach(string => {
        titleHTML += '<span class="mr-1">' + string + "</span>";
      });

      return titleHTML;
    },
    assinaturas: function() {
      let assinaturasHTML =
        "<div>";
      // let assinaturasPorColuna =
      //   this.quantidade / (this.colunas ? this.colunas : 1);
      let indiceAssinatura = 1;

      for (var i = 0; i < this.colunas; i++) {
        let assinaturaColunaHTML =
          "<span>";
        
        for (
          var j = 0;
          j < this.quantidade / (this.colunas ? this.colunas : 1);
          j++
        ) {
          let indice = ( indiceAssinatura <= 5 ? ( indiceAssinatura * 2 ) - 1 : ( indiceAssinatura - 5 ) * 2 );
          let data = ( this.datas && this.datas[indice - 1] ? this.$util.getFormatDate(this.datas[indice - 1]) : '___/___/_____' );

          assinaturaColunaHTML +=
            "<span class='text-right mr-1'>" +
            ( indice ) +
            ":" + data + "  _____________________</span>";

          if ( indiceAssinatura == 5 )
            assinaturaColunaHTML += "<br>";

          indiceAssinatura++;
        }

        assinaturaColunaHTML += "</span>";
        assinaturasHTML += assinaturaColunaHTML;
      }
      assinaturasHTML += "</div>";

      return assinaturasHTML;
    }
  }
};
</script>

<style>
</style>
